import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {TarjetaResumenDatosComponent} from "./tarjeta-resumen-datos.component";

@NgModule({
  declarations: [
    TarjetaResumenDatosComponent
  ],
  exports: [
    TarjetaResumenDatosComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ]
})
export class TarjetaResumenDatosModule {
}
